
//   return (
//     <div className="flex" >
      
//       {/* Sidebar */}
//       <aside key={key}
//         className={`fixed top-0 left-0 h-screen bg-gray-100 p-5 flex flex-col transition-all duration-300 z-50 shadow-lg overflow-y-auto
//           ${isOpen ? "w-64" : "w-0"} 
//           ${isMobile ? "fixed bg-white" : "fixed"} 
//         `}
//         style={{ visibility: isOpen ? "visible" : "hidden" }}
//       >
//         {isOpen && (
//           <>
//             {/* Logo */}
//             <div className="flex justify-center">
//               {/* <img src="/logo.png" alt="Logo" className="h-7" /> */}
//             <img
//               src="/logo.png"  
//               alt="Logo"
//               className="cursor-pointer w-23 h-auto mb-6" // Adjust size as needed
//               onClick={() => navigate("/styleuai")} // Redirect to StyleUAI page
//              />
//             </div>

//             {/* Navigation Links */}
//             <nav className="mt-5 flex-grow">
//               <ul className="space-y-2">
//                 <li>
//                   <Link
//                     to="/myassets"
//                     className={`flex items-center gap-2 p-2 rounded-md  ${
//                       location.pathname === "/myassets"
//                         ? "bg-purple-500 text-white"
//                         : "hover:bg-gray-200"
//                     }`}
//                   >
//                    <Package size={20} /> My Assets
//                   </Link>
//                 </li>
//                 <li>
//                   <Link
//                     to="/styleuai"
//                     className={`flex items-center gap-2 p-2 rounded-md  ${
//                       location.pathname === "/styleuai"
//                         ? "bg-purple-500 text-white"
//                         : "hover:bg-gray-200"
//                     }`}
//                   >
//                     <Wand2 size={20} /> StyleUAI
//                   </Link>
//                 </li>
//                 <li>
//                   <Link
//                     to="/outputs"
//                     className={`flex items-center gap-2 p-2 rounded-md  ${
//                       location.pathname === "/outputs"
//                         ? "bg-purple-500 text-white"
//                         : "hover:bg-gray-200"
//                     }`}
//                   >
//                     <Upload size={20} /> Outputs
//                   </Link>
//                 </li>
//               </ul>
//             </nav>

//             {/* Settings Button */}
//             <div className="relative" ref={settingsRef}>
//               <button
//                 onClick={() => setIsSettingsOpen(!isSettingsOpen)}
//                 className="text-gray-700 w-full text-left p-2 rounded-md hover:bg-gray-200 flex justify-between"
//               >
//                 <Settings size={20} /> Settings
//                 <span>{isSettingsOpen ? "▲" : "▼"}</span>
//               </button>

//               {isSettingsOpen && (
//                 <div className="absolute left-0 bottom-full mb-2 w-48 bg-white shadow-md rounded-md z-50 border border-gray-300">
//                   <button
//                     onClick={() => navigate("/myprofile")}
//                     className="block w-full text-left px-4 py-2 text-gray-700 hover:bg-gray-200"
//                   >
//                     My Profile
//                   </button>
//                   <button
//                     onClick={handlePurchase}
//                     className="block w-full text-left px-4 py-2 text-gray-700 hover:bg-gray-200"
//                   >
//                     Buy Subscription
//                   </button>
//                 </div>
//               )}

//               {/* Logout Button */}
//               <button
//                 onClick={handleLogout}
//                 className="mt-2 w-full text-left text-red-500 p-2 rounded-md hover:bg-gray-200"
//               >
//                 <LogOut size={20} /> Logout
//               </button>
//             </div>
//           </>
//         )}
//       </aside>

//       {/* Toggle Button */}
//       <button
//         onClick={toggleSidebar}
//         className={`fixed top-5 bg-white border border-gray-300 p-2 rounded-full shadow-md z-50 transition-all
//           ${isOpen ? (isMobile ? "left-2" : "left-[270px]") : "left-2"}`}
//       >
//         {isOpen ? <FiChevronLeft size={16} /> : <FiChevronRight size={16} />}
//       </button>

//       {/* Main Content */}
//       <main
//         className={`transition-all duration-300 flex-grow p-5 h-screen overflow-x-auto 
//           ${isOpen && !isMobile ? "ml-64" : "ml-0"}`}
//       >
//         {/* Page Content */}
//       </main>
//     </div>
//   );
// }

// export default Sidebar;

import { useState,useRef, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { FiChevronLeft, FiChevronRight } from "react-icons/fi";
import { auth, db } from "../firebase";
import { onAuthStateChanged } from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";
import UpgradeModal from "../components/UpgradeModal";
import { canAccessFeature, featurePlanMap } from "../utils/featureAccess";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { BadgeDollarSign } from "lucide-react";
import { Package, Wand2, Crown, Upload, Landmark,Film, Settings, LogOut, Globe,Scissors , Sparkles, Video} from "lucide-react";
function Sidebar() {
  const [isOpen, setIsOpen] = useState(window.innerWidth > 768);
  const [isSettingsOpen, setIsSettingsOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [user, setUser] = useState(null);
  const location = useLocation();
  const settingsRef = useRef(null);
  const navigate = useNavigate();
  const [key, setKey] = useState(0);
  const [userData, setUserData] = useState(null);
  const [showUpgradeModal, setShowUpgradeModal] = useState(false);
  const [pendingPath, setPendingPath] = useState("");
  // const accessible = canAccessFeature(userData, id);

  useEffect(() => {
    setKey((prev) => prev + 1); // Update key to force re-render
  }, [location.pathname]);

  // Track auth state changes
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      if (currentUser) {
        setUser(currentUser);
        const docRef = doc(db, "users", currentUser.uid);
        getDoc(docRef).then((docSnap) => {
          if (docSnap.exists()) {
            setUserData(docSnap.data());
          }
        });
      }      
    });
    return () => unsubscribe();
  }, []);

  // Resize handler
  useEffect(() => {
    const handleResize = () => {
      const mobileView = window.innerWidth <= 768;
      setIsMobile(mobileView);
      if (mobileView) {
        setIsOpen(false);
      } else {
        setIsOpen(true);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);


  // Function to handle click outside the settings dropdown
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (settingsRef.current && !settingsRef.current.contains(event.target)) {
        setIsSettingsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  // Toggle Sidebar
  const toggleSidebar = () => setIsOpen((prev) => !prev);

  
const handlePurchase = () => {
  if (!user) {
    alert("You need to log in to purchase credits.");
    return;
  }

  const checkoutUrl = `https://${encodeURIComponent(process.env.REACT_APP_CHARGEBEE_SITE)}.chargebee.com/hosted_pages/checkout?subscription_items[item_price_id][0]=${encodeURIComponent(process.env.REACT_APP_CHARGEBEE_PLAN_ID)}&subscription_items[quantity][0]=1&layout=full_page`;
  
  window.location.href = checkoutUrl; // Redirect to Chargebee checkout
};
  
  // Logout function
  const handleLogout = async () => {
    try {
      await auth.signOut(); // Sign out from Firebase
      localStorage.removeItem("userToken"); // Remove token from local storage
      toast.success("You have been logged out successfully!", {
        position: "top-right",
        autoClose: 3000, // Closes after 3 seconds
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        theme: "light",
      });
  
      setTimeout(() => {
        navigate("/");
      }, 1500); // Redirect after 1.5 seconds
    } catch (error) {
      console.error("Logout Error:", error);
      toast.error("An error occurred while logging out. Please try again.");
    }
  };
  if (!userData) return null; // Prevent rendering until user data is loaded

  return (
    <div>
      <ToastContainer/>
      {/* Sidebar */}
      <aside
        className={`fixed top-0 h-screen bg-[#F7F5FF] backdrop-blur-lg p-5 flex flex-col transition-all duration-500 z-50 shadow-2xl overflow-hidden
          ${isOpen ? "w-64 left-0" : "w-0 -left-64"} 
          ${isMobile ? "fixed bg-white" : "fixed"}
        `}
      >
        {/* Logo */}
        <div className="flex justify-center">
          <img
            src="/logo.png"
            alt="Logo"
            className="cursor-pointer w-25 h-8 mb-6 transition-all hover:scale-105"
            onClick={() => navigate("/styleuai")}
          />
        </div>



        {/* Navigation Links */}
        <nav className="mt-5 flex-grow overflow-y-auto">
          <ul className="space-y-3">
  {[
    { id: "myassets", path: "/myassets", icon: <Package size={15} />, label: "My Assets" },
    { id: "styleuai", path: "/styleuai", icon: <Wand2 size={15} />, label: "StyleUAI" },
    { id: "videogenerator", path: "/video-generator", icon: <Video size={15} />, label: "Video Generator" },
    { id: "seocontent", path: "/SeoContent", icon: <Globe size={15} />, label: "SEO Content" },
    { id: "bgremover", path: "/BgRemover", icon: <Scissors size={15} />, label: "Background Remover" },
    { id: "enhancer", path: "/ImageEnhancer", icon: <Sparkles size={15} />, label: "Image Enhancer" },
    { id: "bggenerator", path: "/BgGenerator", icon: <Landmark size={15} />, label: "Background Generator" },
    { id: "influencer", path: "/Influencer", icon: <Film size={15} />, label: "Influencer Shoot" },
    { id: "outputs", path: "/outputs", icon: <Upload size={15} />, label: "Outputs" },
    { id: "PricingPlan", path: "/PricingPlan", icon: <BadgeDollarSign size={15} />, label: "Pricing" },
  ].map(({ id, path, icon, label }) => {
    const accessible = canAccessFeature(userData, id);

    return (
      <li key={path}>
        <div
          onClick={() => {
            if (!accessible) {
              setPendingPath(path);
              setShowUpgradeModal(true);
            } else {
              navigate(path);
            }
          }}
          className={`flex items-center justify-between gap-2 p-2 rounded-lg cursor-pointer transition-all duration-300
            ${location.pathname === path ? "bg-[#3913C5] text-white shadow-lg" : "hover:bg-gray-200"}
          `}
        >
          <div className="flex items-center gap-2">
            {icon}
            {isOpen && <span className="text-sm font-small">{label}</span>}
          </div>
          {!accessible && <Crown className="text-yellow-500 w-4 h-4" />}
        </div>
      </li>
    );
  })}
</ul>

        </nav>

        {/* Settings & Logout */}
        <div className="space-y-3">
          {/* Settings Button */}
          <div className="relative flex items-center" ref={settingsRef}>
            <button
              onClick={() => setIsSettingsOpen(!isSettingsOpen)}
              className="flex items-center gap-3 w-full p-3 rounded-lg transition-all duration-300 hover:bg-gray-200"
            >
              <Settings size={20} />
              {isOpen && <span className="text-sm font-medium">Settings</span>}
            </button>

            {/* Settings Dropdown */}
            {isSettingsOpen && (
              <div className="absolute left-0 bottom-full mb-2 w-48 bg-white shadow-lg rounded-lg z-50 border border-gray-300">
                <button
                  onClick={() => navigate("/myprofile")}
                  className="flex items-center gap-2 w-full px-4 py-2 text-gray-700 hover:bg-gray-200"
                >
                  <Settings size={18} />
                  <span className="text-sm">My Profile</span>
                </button>
                <button
                  // onClick={handlePurchase}
                  onClick={() => navigate("/PricingPlan")}
                  className="flex items-center gap-2 w-full px-4 py-2 text-gray-700 hover:bg-gray-200"
                >
                  <Package size={18} />
                  <span className="text-sm">Manage Subscription</span>
                </button>
              </div>
            )}
          </div>

          {/* Logout Button */}
          <button
            onClick={handleLogout}
            className="flex items-center gap-3 w-full text-red-500 p-3 rounded-lg transition-all duration-300 hover:bg-gray-200"
          >
            <LogOut size={20} />
            {isOpen && <span className="text-sm font-medium">Logout</span>}
          </button>
        </div>
      </aside>

      {/* Toggle Button (Only visible on mobile) */}
      <button
        onClick={toggleSidebar}
        className={`fixed top-5 bg-purple-500 text-white border border-gray-300 p-3 rounded-full shadow-lg transition-all duration-300 z-50
          ${isOpen ? "left-[270px]" : "left-5"}
          md:hidden
        `}
      >
        {isOpen ? <FiChevronLeft size={20} /> : <FiChevronRight size={20} />}
      </button>

      {/* Main Content */}
      <main
        className={`transition-all duration-300 flex-grow p-5 h-screen overflow-y-auto
          ${isOpen && !isMobile ? "ml-64" : "ml-0"}
        `}
      >
        {/* Page Content */}
      </main>
      <UpgradeModal
        show={showUpgradeModal}
        onClose={() => setShowUpgradeModal(false)}
        onUpgrade={() => {
          setShowUpgradeModal(false);
          navigate("/PricingPlan");
        }}
      />

    </div>
  );

}

export default Sidebar;
